import { UseCase } from './UseCase';
export class TableStoolAvailableUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.onEvent();
    }
    onEvent() {
        return this.applicationServices.bar.nextOccupiedBarStool()
            .then(occupiedBarStool => occupiedBarStool
            ? this.onOccupiedBarStool(occupiedBarStool)
            : Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onOccupiedBarStool(occupiedBarStool) {
        return this.applicationServices.bar.hasAvailableTableStool()
            .then(isTableStoolAvailable => isTableStoolAvailable
            ? this.onTableStoolAvailable(occupiedBarStool)
            : this.applicationServices.bar.askForNewTable())
            .catch(error => Promise.reject(error));
    }
    onTableStoolAvailable(occupiedBarStool) {
        return this.applicationServices.bar.installPlayerFromBarStoolToTableStool(occupiedBarStool)
            .then(() => this.onEvent())
            .catch(error => Promise.reject(error));
    }
}
